import React from 'react'

import ContentContainer from '../Commons/ContentContainer'

const News = () => {
  return <ContentContainer>News</ContentContainer>
}

export default News
